import { useQuery } from '@tanstack/react-query';
import {
  fetchPublicMenuItems,
  SupabaseServiceError,
} from '@/services/menuService';
import { MenuItem } from '@/types';

export const usePublicMenuItems = (params: { categoryId?: string; branchId?: string }) => {
  const { categoryId, branchId } = params;

  const queryKey = ['publicMenuItems', categoryId, branchId];

  const { data: menuItems, isLoading: loading, error, refetch } = useQuery<
    MenuItem[],
    SupabaseServiceError
  >({
    queryKey,
    queryFn: () => fetchPublicMenuItems({ categoryId, branchId }),
    enabled: !!categoryId || !!branchId,
    staleTime: 1000 * 60 * 1, // 1 minute
    gcTime: 1000 * 60 * 5, // 5 minutes
  });

  return {
    menuItems: menuItems || [],
    loading,
    error,
    refetch,
  };
};
